<template>
    <div class="header_template">
        <div v-if="!isWxMiniProgram"  class="onon-header">
            <div style="display: flex;align-items: center;height: 100%;">
                <a style="height: 32px;" :href="config.OnonTechUrl">
                    <img class="logomax" src="@/assets/logo-onon.png" alt="OnonTTS-蒙古文语音合成">
                    <img class="logomin" style="height: 100%;" src="@/assets/logo-icon.png" alt="蒙古语语音合成">
                </a>
                <div :class="this.$i18n.locale == 'zh-CN'? 'onon_tool_cn':'onon_tool'">
                    <a :href="config.OnonMTUrl" class="ot_item">
                        <img class="oicon" src="@/assets/images/icon/translate.svg" alt="蒙古文朗读">
                        {{$t("mt")}}
                    </a>
                    
                    <a :href="config.OnonProofreadUrl" class="ot_item">
                        <img class="oicon" src="@/assets/images/icon/proof.svg" alt="蒙语合成语音">
                        {{$t('proofread')}}
                    </a>
                    
                    <a :href="config.OnonOCRUrl" class="ot_item">
                        <img class="oicon" src="@/assets/images/icon/ocr.svg" alt="蒙文语音转换" color="#3ec387">
                        {{$t("ocr")}}
                    </a>

                    <a class="ot_item ot_active">
                        <img class="oicon" src="@/assets/images/icon/tts.svg" alt="Onon icon"> {{$t("tts")}}
                    </a>

                    <a :href="config.OnonCodeConversionUrl" class="ot_item">
                        <img class="oicon" src="@/assets/images/icon/code.svg" alt="Onon icon">        
                            {{$t("platformnameforcodeconvert")}}
                        <span class="xm-1"> {{$t("limitedExemption")}}</span>
                    </a>
                    
                    <a :href="config.OnonMongolianConversionUrl" class="ot_item">
                        <img class="oicon" src="@/assets/images/icon/language-km.svg" alt="Onon icon"> {{$t("platformnameforconvert")}}
                        <span class="xm-1"> {{$t("limitedExemption")}}</span>
                    </a>
                </div>

            </div>

            <div class="product-wrap">
                <div :class="this.$i18n.locale == 'zh-CN'? 'm_menu_cn':'m_menu'">
                    <Dropdown trigger="click" placement="bottom-end" :transfer="true" style="margin-left: 20px">
                        <a href="javascript:void(0)">
                            <Icon style="cursor: pointer; color: var(--header-theme-color);" id="some-element10" type="ios-keypad" :color="isShowProduct?'#4a90e2':''" size="24" />
                        </a>
                        <DropdownMenu slot="list">
                            <DropdownItem>
                                <a :href="config.OnonMTUrl" class="mNavItem">
                                <img class="mniIcon" src="@/assets/images/icon/translate.svg" alt="Onon icon">
                                    {{$t("mt")}}
                                </a>
                            </DropdownItem>

                            <DropdownItem >
                                <a :href="config.OnonProofreadUrl" class="mNavItem">
                                <img class="mniIcon" src="@/assets/images/icon/proof.svg" alt="Onon icon">
                                {{$t('proofread')}}</a>
                            </DropdownItem>

                            <DropdownItem >
                                <a :href="config.OnonOCRUrl"  class="mNavItem" >
                                <img class="mniIcon" src="@/assets/images/icon/ocr.svg" alt="Onon icon" color="#3ec387">
                                {{$t("ocr")}}</a>
                            </DropdownItem>

                            <DropdownItem >
                                <a class="mNavItem router-link-active">
                                <img class="mniIcon" src="@/assets/images/icon/tts.svg" alt="Onon icon" color="#3ec387">
                                {{$t("tts")}}</a>
                            </DropdownItem>
                            
                            <DropdownItem>
                                <a :href="config.OnonCodeConversionUrl"  class="mNavItem">
                                    <img class="mniIcon" src="@/assets/images/icon/code.svg" alt="Onon icon">
                                    {{$t("platformnameforcodeconvert")}}
                                    <span class="xm">( {{$t("limitedExemption")}} )</span>
                                </a>
                            </DropdownItem>

                            <DropdownItem>
                                <a :href="config.OnonMongolianConversionUrl" class="mNavItem">
                                    <img class="mniIcon" src="@/assets/images/icon/language-km.svg" alt="Onon icon">
                                    {{$t("platformnameforconvert")}}
                                    <span class="xm">( {{$t("limitedExemption")}} )</span>
                                </a>
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </div>
                            


                <!-- 登录 start -->
                <div class="user_info" v-if="isLoggedIn" @click="getTraffic">

                    <div class="discount-banner" v-if="this.isNewUser">
                        {{this.getuserInfo?.ou?.discountDesc.split("-")[0]}}
                    </div>

                    <a :href="this.$config.vipService" v-show="this.$store.state.userInfo?.isSvip !== 1" class="openVip">{{$t("openVip")}}</a>

                    <Dropdown trigger="click" placement="bottom-end" :transfer="true" @on-click="dropdownClick">                     
                        <Avatar icon="ios-person" :src="this.$store.state.userInfo?.avatar ? this.$store.state.userInfo?.avatar : require('@/assets/images/avatar.png')"/>
                        <span v-show="this.$store.state.userInfo?.isSvip == 1" class="userVip"></span>

                        <DropdownMenu slot="list">
                            <div class="dm-username" style="padding:8px 16px 0; font-size:16px;text-align:center; ">
                                {{this.$store.state.userInfo?.nickname}}
                                <DropdownItem :name="'editUsername'" style="display: contents;">
                                    <img style="width:18px;height:18px;margin-left:4px;" src="@/assets/images/icon/edit-line.svg" alt="">
                                </DropdownItem>
                            </div>
                            <div v-show="this.$store.state.userInfo?.svipExpireDate && this.$store.state.userInfo?.isSvip == 1" class="svipExpireDate">                   
                                {{$t('myMembers')}}: {{this.$store.state.userInfo?.svipExpireDate}} {{$t('maturity')}}
                            </div>
                            <div class="remainingFlow" style="text-align: center;">
                                <div>
                                    {{$t('remainingFlow')}} ({{$t('character')}})
                                </div>
                                <div class="progressBar">
                                    <Progress :percent="percent" :stroke-width="12" stroke-color="#3ec387" />
                                </div>
                                <div>
                                    {{formatNumber(canCount)}} / {{formatNumber(totalCount)}}
                                </div>
                                
                            </div>

                            <div class="remainingFlow2" style="text-align: center;">
                                <div>
                                    {{$t('remainingFlow')}} ({{$t('frequency')}})
                                </div>
                                <div class="progressBar">
                                    <Progress :percent="frequencyPercent" :stroke-width="12" stroke-color="#3ec387" />
                                </div>
                                <div>
                                    {{availableCallCount}} / {{grantCallCount}}
                                </div>
                                
                            </div>
                            
                            <div class="user_model row-col-2">
                                <div class="um-item">
                                    <a>
                                        <DropdownItem :name="'myTraffic'">
                                            <img style="width:16px;height:16px;margin-right:4px;" src="@/assets/images/icon/wodeziyuan.svg" alt="">
                                            {{$t("myTraffic")}}
                                        </DropdownItem>
                                    </a>
                                </div>
                                <div class="um-item">
                                    <a>
                                        <DropdownItem :name="'orderManagement'">
                                            <img style="width:16px;height:16px;margin-right:4px;" src="@/assets/images/icon/dingdan.svg" alt="">
                                            {{$t("orderManagement")}}
                                        </DropdownItem>
                                    </a>
                                </div>
                                <div class="um-item">
                                    <a>
                                        <DropdownItem :name="'invoiceManagement'">
                                            <img style="width:16px;height:16px;margin-right:4px;" src="@/assets/images/icon/fapiao.svg" alt="">
                                            {{$t("invoiceManagement")}}
                                        </DropdownItem>
                                    </a>
                                </div>
                                <div class="um-item">
                                    <a>
                                        <DropdownItem :name="'personalCenter'">
                                            <img style="width:16px;height:16px;margin-right:4px;" src="@/assets/images/icon/user.svg" alt="">
                                            {{$t("userCenter")}}
                                        </DropdownItem>
                                    </a>
                                </div>
                            </div>
                           
                            <DropdownItem :name="'signOut'" divided class="flex-center" style="justify-content: end;">
                                <img style="width:16px;height:16px;margin-right:4px;" src="@/assets/images/icon/logout.svg" alt="">
                                {{$t("logout")}}
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </div>  
                <button type="butotn" class="login_btn" @click="login" v-else>{{$t("login")}}</button>
                <!-- 登录 end --> 

            </div>
        </div>


        <div v-else class="wxmp_nav" :style="{top: getBannerImgHeight + 'px'}">
            <!-- 登录 start -->
            <div class="user_info" v-if="isAuthenticated" @click="getTraffic">

                <!-- 开通会员 -->
                <a :href="this.$config.vipService" 
                v-show="this.$store.state.userInfo?.isSvip !== 1" 
                style="margin-right:-34px;"
                class="openVip">{{$t("openVip")}}</a>

                <Dropdown trigger="click" placement="bottom-end" :transfer="true" @on-click="dropdownClick">                     
                    <Avatar icon="ios-person" :src="this.$store.state.userInfo?.avatar ? this.$store.state.userInfo?.avatar : require('@/assets/images/avatar.png')"/>
                    <span v-show="this.$store.state.userInfo?.isSvip == 1" class="userVip"></span>
                    <span v-show="shrink" class="oh_username">
                        {{this.$store.state.userInfo?.nickname}}
                    </span>
                    <Icon v-show="shrink" type="ios-arrow-down"  size="14"/>

                    <DropdownMenu slot="list">
                        <div class="dm-username" style="padding:8px 16px 0; font-size:16px;text-align:center; ">
                            {{this.$store.state.userInfo?.nickname}}
                            <DropdownItem :name="'editUsername'" style="display: contents;"><span class="iconfont" style="font-size:18px;">&#xe987;</span></DropdownItem>
                        </div>

                        <div v-show="this.$store.state.userInfo?.svipExpireDate && this.$store.state.userInfo?.isSvip == 1" class="svipExpireDate">                   
                            {{$t('myMembers')}}: {{this.$store.state.userInfo?.svipExpireDate}} {{$t('maturity')}}
                        </div>
                        <div class="remainingFlow" style="text-align: center;">
                            <div>
                            {{$t('remainingFlow')}} ({{$t('character')}})

                            </div>
                            <div class="progressBar">
                                <Progress :percent="percent" :stroke-width="12" stroke-color="#3ec387" />
                            </div>
                            <div>
                                {{formatNumber(canCount)}} / {{formatNumber(totalCount)}}
                            </div>
                            
                        </div>

                        <div class="remainingFlow2" style="text-align: center;">
                            <div>
                                {{$t('remainingFlow')}} ({{$t('frequency')}})
                            </div>
                            <div class="progressBar">
                                <Progress :percent="frequencyPercent" :stroke-width="12" stroke-color="#3ec387" />
                            </div>
                            <div>
                                {{availableCallCount}} / {{grantCallCount}}
                            </div>
                            
                        </div>
                        
                        <div class="user_model row-col-2">
                            <div class="um-item">
                                <a>
                                    <DropdownItem :name="'myTraffic'">
                                        <img style="width:16px;height:16px;margin-right:4px;" src="@/assets/images/icon/wodeziyuan.svg" alt="">
                                        {{$t("myTraffic")}}
                                    </DropdownItem>
                                </a>
                            </div>
                            <div class="um-item">
                                <a>
                                    <DropdownItem :name="'orderManagement'">
                                        <img style="width:16px;height:16px;margin-right:4px;" src="@/assets/images/icon/dingdan.svg" alt="">
                                        {{$t("orderManagement")}}
                                    </DropdownItem>
                                </a>
                            </div>
                            <div class="um-item">
                                <a>
                                    <DropdownItem :name="'invoiceManagement'">
                                        <img style="width:16px;height:16px;margin-right:4px;" src="@/assets/images/icon/fapiao.svg" alt="">
                                        {{$t("invoiceManagement")}}
                                    </DropdownItem>
                                </a>
                            </div>
                            <div class="um-item">
                                <a>
                                    <DropdownItem :name="'personalCenter'">
                                        <img style="width:16px;height:16px;margin-right:4px;" src="@/assets/images/icon/user.svg" alt="">
                                        {{$t("userCenter")}}
                                    </DropdownItem>
                                </a>
                            </div>
                        </div>
                        
                        <DropdownItem :name="'signOut'" divided class="flex-center" style="justify-content: end;">
                            <img style="width:16px;height:16px;margin-right:4px;" src="@/assets/images/icon/logout.svg" alt="">
                            {{$t("logout")}}
                        </DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </div>
            <button v-else type="butotn" class="wxmp_login_btn" @click="login" >
                {{$t("login")}}
            </button>
            <!-- 登录 end --> 
        </div>

        <AppPopup v-if="isNewUser" :title="getUserInfo?.ou?.discountDesc.split('-')[0]" :content="getUserInfo?.ou?.discountDesc.split('-')[1]" 
        :modelValue="newUser" @confirm="popupFun"></AppPopup>

    </div>
</template>

<script>
    import { mapGetters,mapActions } from 'vuex';
    import AppPopup from "@/components/popup";
    import GlobalConfig from '@/config/globalConfig';
    import axios from 'axios';
    
    export default {
        name: "AppNavbar",
        data() {
            return {
                config: GlobalConfig,
                isShowProduct: false,
                getEnv:"pcmessenger",
                isSticky: false,
                percent: 0,
                canCount: 0, //剩余流量
                totalCount: 0,//总流量
                availableCallCount: 0,
                grantCallCount: 0,
                frequencyPercent: 0,

                wxApplets: false,
                newUser: true,
                isWxMiniProgram: false
            }
        },
        props: {
            shrink: {
                type: Boolean,
                default: true
            },
            platformType: {
                type: Number,
                default: 1
            }
        },
        components: {
            AppPopup
        },
        computed: {
            ...mapGetters(['isLoggedIn','isNewUser','getUserInfo','userToken']),
        },
        methods: {
            ...mapActions(['logout','setNewUser']),
            popupFun() {
                this.newUser = false;
            },
            login() {
                this.$utils.login();
            },
            dropdownClick(type) {
                let that = this;
                switch (type) {
                    case "myTraffic":
                        window.location.href = that.$config.myTraffic;
                        break;
                    case "personalCenter":
                        window.location.href = that.$config.individualCenter;
                        break;
                    case "editUsername":
                        window.location.href = that.$config.individualCenter;
                        break;
                    case "orderManagement":
                        window.location.href = that.$config.orderManagement;
                        break;
                    case "invoiceManagement":
                        window.location.href = that.$config.invoiceManagement;
                        break;
                    case "signOut":

                        var url = this.$config.debugMode ? '/login' : this.$config.loginBaseUrl;
                        axios.get( url + '/onon/openapi/auth/logouts?access_token=' + 
                        this.userToken, '').then(res => {
                            // console.log(res);
                            if (res.data.success) {
                                this.$store.dispatch('logout');
                                this.$Message.success('已退出登录');
                            } else {
                                this.$Message.success(res.data.message);
                            }
                        }).catch(err => {
                            console.log(err);
                        }) 
                        break;
                    default:
                        break;
                }
                
            },
            toConvert() {
                this.$Message.warning('蒙古文转换系统网站正在改版中...');
            },
            changeLocaleLangHandler() {
                this.$emit('changeLocaleLangHandler')
            },
            showProductLink() {
                this.isShowProduct = !this.isShowProduct
            },
            getTraffic() {
                // console.log('getTraffic:',this.$store.state.isRequest);
                if(this.$store.state.isRequest) {
                    let fd = {
                        svid: 4
                    }
                    axios.post(this.$config.loginBaseUrl + 
                    '/onon/openapi/getGrantServiceCallCount?access_token=' + 
                    this.userToken,fd,{
                        headers: {
                            'Content-Type' : 'application/x-www-form-urlencoded'
                        }
                    }).then(res => {
                        // console.log('getUserInformation',res);
                        if(res.data.code == 200) {
                        
                            this.canCount = res.data.result?.canCountMap.availableCharCount;
                            this.totalCount = res.data.result?.totalCountMap.grantCharCount;
                            this.baifenbi(this.canCount,this.totalCount);

                            this.availableCallCount = res.data.result?.canCountMap.availableCallCount;
                            this.grantCallCount = res.data.result?.totalCountMap.grantCallCount;
                            this.frequencyBaifenbi(this.availableCallCount,this.grantCallCount);
                            
                            this.$store.state.isRequest = false;
                        }
                    })
                }
            },
            formatNumber(value) {
                if (value >= 10000) {
                    var result = (value / 1000).toFixed(2)
                    return result.replace(/\.?0*$/, '') + 'k'
                    // '万'
                } else {
                    return value.toString()
                }
            },
            baifenbi(can,total) {
                if(total == 0){
                    this.percent = 0
                } else {
                    let percentage = (can / total) * 100;
                    percentage = percentage.toFixed(2);
                    this.percent = Number( percentage )
                }
            },
            frequencyBaifenbi(can,total) {
                if(total == 0){
                    this.frequencyPercent = 0
                } else {
                    let percentage = (can / total) * 100;
                    percentage = percentage.toFixed(2);
                    this.frequencyPercent = percentage
                }
            },

        },
        mounted(){
            var ua = navigator.userAgent.toLowerCase()
          
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                this.getEnv = "micromessenger"
                this.wxApplets = true;
               
            } else {
                this.getEnv = "pcmessenger"
                
            }

            if(this.isLoggedIn) {
                this.$store.state.isRequest = true;
                this.getTraffic();
            }

        },
        beforeDestroy() {
        },

    };
</script>

<style lang="less">
 @import './nav.less';
</style>
